import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import { StyledLink } from '@/components/shared/StyledLink';

export type HeaderVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

export type HeaderProps = PropsWithChildren<{
  className?: string;
  variant: HeaderVariants;
  navigateTo?: string;
}>;

const variantClasses: Record<HeaderVariants, string> = {
  h1: 'tw:text-header-h1 tw:tracking-[-0.0025em]',
  h2: 'tw:text-header-h2 tw:tracking-[0]',
  h3: 'tw:text-header-h3 tw:tracking-[0.0025em]',
  h4: 'tw:text-header-h4 tw:tracking-[0.0025em]',
  h5: 'tw:text-header-h5 tw:tracking-body',
};

export const Header = ({
  children,
  className,
  variant,
  navigateTo,
}: HeaderProps) => {
  const headerClassName = classNames(
    'tw:leading-header tw:font-bold tw:text-header',
    variantClasses[variant],
    className,
  );

  const ElementComponent = variant;

  const content = navigateTo ? (
    <StyledLink to={navigateTo}>{children}</StyledLink>
  ) : (
    children
  );

  return (
    <ElementComponent className={headerClassName}>
      {content}
    </ElementComponent>
  );
};
